
import type { PropType } from 'vue';

import { defineComponent } from 'vue';

import type { FeedCreative } from '@/types';

export default defineComponent({
  props: {
    creative: {
      type: Object as PropType<FeedCreative>,
      required: true,
    },
  },
  setup() {
    const onImageError = (event: Event): void => {
      const target = event.target as HTMLImageElement;

      target.src = '/assets/img/broken.jpg';
    };

    return {
      onImageError,
    };
  },
});
